import lazyPictureLoad from '../../lazypictureload';

export function init() {
    if (SitePreferences.ENABLE_IMAGE_LAZYLOAD) {
        const lazyLoadConfig = { observerId: 'pt_blog-result', preloadExpandBy: 100 };
        lazyPictureLoad.init(lazyLoadConfig);
    }
}


// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/blog/index.js